import { stringValidationYup } from "helpers/validations"
import { t } from "i18next"
import * as yup from "yup"

const getInvestmentValidationSchema = () =>
  yup.object().shape({
    interestedProjectId: yup.mixed().required(t("Please select a project")),
    dealValue: yup.number().required(t("Please enter deal value")).nullable(),
    expectedRevenue: yup.number().required(t("Please enter expected revenue")).nullable(),
    pipelineSubStageId: yup.string().required(t("Please select pipeline sub stage")).nullable(),
    pipelineStageId: yup.string().required(t("Please select pipeline stage")).nullable(),
    probabilityManual: yup.number().required(t("Please add probability")).nullable(),
    closingMonth: yup.mixed().required(t("Please select closing month")).nullable(),
    comment: stringValidationYup().required(t("Comment is required")).nullable(),
  })

export default getInvestmentValidationSchema
